import React from 'react';
import withIcon from '../utilities/withIcon';

const IconArrowBox = () => {
  return (
    <g>
      <path d="M12.429,14.422H1.8a.6636.6636,0,0,1-.6644-.6644V3.1281A.6635.6635,0,0,1,1.8,2.4638H5.3426a.6644.6644,0,1,1,0,1.3287H2.4638v9.3008h9.3008V10.2145a.6644.6644,0,1,1,1.3287,0v3.5431A.6635.6635,0,0,1,12.429,14.422Z" />
      <path
        id="ArrowBox-2"
        data-name="ArrowBox"
        d="M14.3733,1.5559c0-.0045,0-.0089-.0045-.0089a.6783.6783,0,0,0-.3631-.3632c-.0045,0-.0089,0-.0089-.0044a.6952.6952,0,0,0-.2392-.0443H8.4429a.6644.6644,0,0,0,0,1.3287h3.7115L7.9734,6.6447a.66.66,0,0,0,0,.939.6629.6629,0,0,0,.939,0l4.1809-4.181V7.1142a.6644.6644,0,1,0,1.3287,0V1.8A.646.646,0,0,0,14.3733,1.5559Z"
      />
      <rect
        x="0.0279"
        y="0.0279"
        width="15.9442"
        height="15.9442"
        fill="none"
      />
    </g>
  );
};

export default withIcon(IconArrowBox);
